module.exports = __webpack_public_path__ + "media/static/icons/icon-chevron-circle-right-ba7fac90109d888ba52e34f9d1c063a6.svg";